export default [{
  path: 'vehicleIotList',
  name: 'vehicleIotList',
  component: function component() {
    return import('@/views/vehicleIotManage/index');
  }
}, {
  path: 'vehicleIotDetails',
  name: 'vehicleIotDetails',
  component: function component() {
    return import('@/views/vehicleIotManage/detail');
  }
}];